import { Component, OnInit } from '@angular/core';
import { BadeLoftService } from '../bade-loft.service';
import { CommonService } from 'src/app/services/common.service';
import { DatePipe } from '@angular/common';
import { ResponseMessageStatus, ResponseStatus, SortBy } from 'src/app/shared/enums';

@Component({
  selector: 'app-return',
  templateUrl: './return.component.html',
  styleUrls: ['./return.component.css']
})
export class ReturnComponent implements OnInit {

  lst_Status: any = [];
  isStatusLoaded: boolean = false;
  totalRecord: number = 0;
  statusMaxPageSize: number = 0;
  sortField: string = 'returnRequestDate';
  sortBy: number = SortBy.Dsc;
  statusList_Request: any;
  currentStatus: any = 1;

  constructor(
    private _blS: BadeLoftService,
    public _cS: CommonService,
    private _datepipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getReturnAssignmentsData();
  }

  getReturnAssignmentsData() {
    this._blS.GetReturnAssignmentsData( this.sortField, this.sortBy,).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          var data = res.result.records;
          this.totalRecord = res.result.totalRecord;
          this.statusMaxPageSize = res.result.totalPage;
          this.lst_Status = [];
          if (data && data.length > 0) {
            data.forEach((x: any) => {
              this.lst_Status.push(x);
            });
          }
          this.lst_Status.map((x: any) => {
            x.expand = false;
          });
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
      this.isStatusLoaded = false;
    });
  }

  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      if (this.statusList_Request) this.statusList_Request.unsubscribe();
      if (this.currentStatus == 1) {
        this.getReturnAssignmentsData();
      }
    }
  }


  //#region Edit Tracking Number

  editTrackingNo(data: any): void {
    data.isEditing = true;
    data.tempTrackingNo = data.returnTrackingNumber;
    data.showButtons = true;
  }

  onInputFocus(data: any): void {
    data.showButtons = true;
  }

  onInputBlur(data: any): void {
    // Optional: You can delay hiding buttons or ignore this method
  }

  updateReturnTrackingNumber(data: any): void {
    data.returnTrackingNumber = data.tempTrackingNo;
    data.isEditing = false;
    data.showButtons = false;

    if (!data.returnTrackingNumber) {
      this._cS.displayMessage(ResponseMessageStatus.error, 'Tracking number cannot be empty.');
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    // Call your update function here
    this._blS.UpdateReturnTrackingNumber(data.id, data.returnTrackingNumber).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }

  cancelTrackingNo(data: any): void {
    data.tempTrackingNo = data.returnTrackingNumber;
    data.isEditing = false;
    data.showButtons = false;
  }

  //endregion Edit Tracking Number


  UpdateDamagedAndB2SStatus(data: any, IsBackToStock: boolean = false, IsDamaged: boolean = false) {
    this._blS.UpdateDamagedAndB2SStatus(data, IsBackToStock, IsDamaged).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }
}
